<div [ngClass]="['overlay-base', setOverlayClass()]">
    <span data-cy="table-row-overlay-message">{{message}}</span>
</div>
